<template>
  <form @submit.prevent="submit">
    <label>{{ i18n.t('/change-order/bulk/title') }}</label>
    <br />
    <div class="input-panel">
      <app-button data-qa="bulk-upload-button" :disabled="isLoading" @click="selectExcelFile">
        <span v-if="!isLoading">{{ i18n.t('/change-order/bulk/upload') }}</span>
        <loader v-else />
      </app-button>

      <app-button data-qa="bulk-template-download-button" @click="downloadTemplate">
        <span>{{ i18n.t('/change-order/bulk/template') }}</span>
      </app-button>
    </div>
    <error-modal
      :title="i18n.t('/change-order/bulk/error-load')"
      :errors="getValidationMessages"
    ></error-modal>
  </form>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import { useFileDialog } from '@vueuse/core'
import BulkChangeOrderService from '@/services/bulkChangeOrderService'
import ErrorModal from '@/components/generic/presentational/atoms/errorModal/ErrorModal.vue'

export default {
  components: {
    ErrorModal,
    Loader,
    AppButton,
  },
  setup() {
    const fileDialog = useFileDialog({
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      multiple: false,
      directory: false,
    })

    return {
      fileDialog,
    }
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      isLoading: false,
      bulkOrderResult: null,
    }
  },
  computed: {
    getValidationMessages() {
      let validationMessages = this.bulkOrderResult?.ValidationMessages
      if (validationMessages?.length > 0) {
        return validationMessages.join(' <br />')
      }
      return validationMessages
    },
  },
  created() {
    this.fileDialog.onChange(this.onChange)
  },
  methods: {
    downloadTemplate() {
      const link = document.createElement('a')
      link.href =
        'https://docs.google.com/spreadsheets/d/1JoINSLmuI62iwDas5Tvd9leAhU2hgPGNPfNXWNzhUBk/edit?usp=sharing'
      link.setAttribute('target', '_blank')
      link.setAttribute('download', 'template.xlsx') //or any other extension
      link.click()
    },
    resetErrors() {
      this.bulkOrderResult = null
    },
    selectExcelFile() {
      this.resetErrors()
      this.fileDialog.open()
    },
    async onChange(files) {
      if (files && files.length > 0) {
        this.isLoading = true
        let selectedFile = files[0]
        console.log('File selected:', selectedFile.name + ' size: ' + selectedFile.size)

        try {
          this.bulkOrderResult = await BulkChangeOrderService.uploadBulkChangeOrder(selectedFile)

          if (this.bulkOrderResult?.BulkChangeOrderId) {
            this.$router.push({
              name: 'bulk-change-order-page',
              params: {
                ...this.$route.params,
                bulkChangeOrderId: this.bulkOrderResult.BulkChangeOrderId,
              },
            })
          }
        } catch (error) {
          console.error('Error uploading file:', error)
        } finally {
          this.isLoading = false
          this.fileDialog.reset()
        }
      } else {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
